import { AssetDtoContentTypeEnum } from "generated";

export const getAcceptedFileTypes = (fileType: AssetDtoContentTypeEnum) => {
  switch (fileType) {
    case AssetDtoContentTypeEnum.Transcript:
      return ".txt";
    case AssetDtoContentTypeEnum.Caption:
      return ".vtt";
    case AssetDtoContentTypeEnum.Subtitle:
      return ".srt";
    default:
      return "";
  }
};

export const validateFile = (file: File, fileType: AssetDtoContentTypeEnum) => {
  return file.name.toLowerCase().endsWith(getAcceptedFileTypes(fileType));
};
